<div fxLayout="row" fxLayoutAlign="space-between center" style="margin: 2% 3% 3%;width: 94%;">
    <div>
        <label class="page-header-title">Welcome!</label>
    </div>
    <div>
        <button type="button"  type="submit" fxLayoutAlign="center center" class="create-bot-btn" fxFlex
            [routerLink]="'/templates/add'" [disabled]="!apiKeyIsGenerated" *ngIf = "allTemplateDetails.length > 0">
            <mat-icon>add</mat-icon> Create New Template
        </button>
        <button type="button"  type="submit" fxLayoutAlign="center center" class="create-bot-btn" fxFlex
             [disabled]="!apiKeyIsGenerated" *ngIf = "allTemplateDetails.length === 0" (click)="openCheckDemo()">
            <mat-icon style="font-size: 12px !important;"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" >
                <path d="M5.70139 0C5.48418 0 5.30825 0.176073 5.30825 0.393142V3.53863C5.30825 3.75584 5.48432 3.93177 5.70139 3.93177C5.9186 3.93177 6.09453 3.7557 6.09453 3.53863V0.393142C6.09453 0.175929 5.91846 0 5.70139 0ZM1.9476 1.55421C1.84694 1.55421 1.74794 1.59425 1.67114 1.67091C1.51756 1.82449 1.51756 2.07023 1.67114 2.22381L3.61867 4.17134C3.77226 4.32492 4.01799 4.32492 4.17158 4.17134C4.32516 4.01775 4.32503 3.77202 4.17158 3.61843L2.22405 1.67091C2.14726 1.59411 2.04825 1.55421 1.9476 1.55421ZM9.45483 1.55421C9.35417 1.55421 9.25517 1.59411 9.17837 1.67091L7.23085 3.61843C7.0774 3.77202 7.07726 4.01775 7.23085 4.17134C7.38443 4.32492 7.63017 4.32492 7.78375 4.17134L9.73128 2.22381C9.88486 2.07023 9.88486 1.82449 9.73128 1.67091C9.65449 1.59411 9.55548 1.55421 9.45483 1.55421ZM5.43012 5.17115C5.26801 5.10821 5.10835 5.26787 5.17129 5.42998L8.53882 14.1031C8.60298 14.2684 8.83452 14.2747 8.90752 14.1131L10.0076 11.6784L12.5019 14.1682C12.9622 14.6276 13.7077 14.6273 14.1676 14.1674C14.6274 13.7075 14.6278 12.9621 14.1683 12.5018L11.6785 10.0075L14.1132 8.90738C14.2748 8.83438 14.2686 8.60284 14.1033 8.53868L5.43012 5.17115ZM0.393142 5.30787C0.17593 5.30787 0 5.48394 0 5.70101C0 5.91822 0.176073 6.09415 0.393142 6.09415H3.52627C3.74349 6.09415 3.91942 5.91808 3.91942 5.70101C3.91942 5.4838 3.74334 5.30787 3.52627 5.30787H0.393142ZM3.89488 7.11399C3.79422 7.11399 3.69522 7.15389 3.61843 7.23069L1.6709 9.17821C1.51731 9.3318 1.51731 9.57753 1.6709 9.73112C1.82448 9.88457 2.07022 9.8847 2.2238 9.73112L4.17133 7.78359C4.32478 7.63001 4.32492 7.38427 4.17133 7.23069C4.09454 7.15389 3.99553 7.11399 3.89488 7.11399Z" fill="#386AF6"/>
                </svg>
                </mat-icon> Check Demo
        </button>
    </div>
</div>
<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="main-img" *ngIf="apiKeyIsGenerated && allTemplateDetails.length == 0">
    <img src="../../assets/create_template.png" class="create-template" />
    <label>Create your template to be shared with customers now</label>
    <a class="btn add btn-primary primary-button" style="width:20vw" [routerLink]="['./add']">Create Template</a>
</div>
<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="main-img" *ngIf="!apiKeyIsGenerated">
    <img src="../../assets/create_template.png" class="create-template" />
    <label class="text-center px-3">Go to homepage to Generate Api Key and create new templates</label>
    <a class="btn add btn-primary primary-button" [routerLink]="['../insights']">Go to Homepage</a>
</div>

<div fxLayout="column" *ngIf="allTemplateDetails.length > 0">
    <div fxLayout="row"  fxLayoutAlign="start center" *ngIf="allTemplateDetails?.length > 0">
        <div fxFlex="30" fxFlexOffset="5%" class="bot-header" style="text-align: left;margin-left: 5%;">Template Name</div>
        <!-- <div fxFlex="21" class="bot-header" style="text-align: center;">Type</div> -->
        <div fxFlex="6" class="bot-header" style="text-align: center;">Status</div>
        <div  fxFlex="38"  class="bot-header" style="text-align: center;">Created date</div>
    </div>
    <div class="bot-list-section" fxLayout="column" fxLayoutAlign="start start"  *ngIf="allTemplateDetails?.length > 0">
        <div  fxFlex="15" class="bot-section" fxLayoutAlign="start center"
            *ngFor="let template of allTemplateDetails; let i=index;" style="margin-bottom:10px;width: 100%;">
            <div fxFlex="32.5"  fxLayout="row" style="justify-content: left !important;margin-left: 2%;">
                <div class="bot-list">{{template.name}}</div>
            </div>
            <!-- <div fxFlex="7" class="divider"></div> -->
            <!-- <div fxFlex="17" class="bot-list"></div> -->
            <div  fxFlex="2"  class="custom-divider"></div>
            <div fxFlex="25" fxLayout="row" *ngIf="template.status == 'ACTIVE'" style="justify-content: center;">
                <div>
                    <div class="active-label">
                        <label>Active</label>
                    </div>
                </div>
            </div>
            <div fxFlex="25" fxLayout="row"  *ngIf="template.status === 'PENDING_REVIEW'" style="justify-content: center;">
                <div>
                    <div class="inactive-label">
                        <label>Pending</label>
                    </div>
                </div>
            </div>
            <div  fxFlex="2"  class="custom-divider"></div>
           <div fxFlex="30" style="text-align: center;">
               <div class="bot-list">{{template.created_at | dateTransform: 'std' }}</div>

           </div>
           <div fxFlex="2" class="custom-divider"></div>
           <div fxFlex="25" style="text-align: center;">
               <div class="bot-list" (click)="onDeleteTemplate(template.name)"
                   style="font-weight: 500;font-size: 12px;line-height: 15px;align-items: center;letter-spacing: 0.02em;color: #386AF6;cursor: pointer;">
                   Delete Template</div>

           </div>
           <div fxFlex="4" fxLayout="row" (click)="goToEditTemplate(template.name)" style="justify-content:right;">
               <button type="button" fxLayoutAlign="center center"class="next-btn" mat-mini-fab>
                    <mat-icon style="height: 22px;width: 28px;">
                        <span class="material-symbols-outlined">
                            chevron_right
                        </span>
                    </mat-icon>
                </button>
            </div>
        </div>

    </div>
</div>
<ng-template id="DeleteTemplate" #DeleteTemplate>
    <button class="close" style="padding: 0px 10px;" mat-button (click)="onCancel()">
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.93909 3.99943L7.80299 1.14179C7.92841 1.01635 7.99886 0.846231 7.99886 0.668843C7.99886 0.491455 7.92841 0.321332 7.80299 0.1959C7.67758 0.0704672 7.50748 0 7.33011 0C7.15275 0 6.98265 0.0704672 6.85724 0.1959L4 3.06021L1.14276 0.1959C1.01735 0.0704672 0.847248 -1.32164e-09 0.669885 0C0.492522 1.32165e-09 0.322423 0.0704672 0.197008 0.1959C0.0715939 0.321332 0.00113664 0.491455 0.00113663 0.668843C0.00113663 0.846231 0.0715939 1.01635 0.197008 1.14179L3.06091 3.99943L0.197008 6.85708C0.134583 6.919 0.085035 6.99267 0.0512219 7.07385C0.0174088 7.15502 0 7.24208 0 7.33002C0 7.41795 0.0174088 7.50502 0.0512219 7.58619C0.085035 7.66737 0.134583 7.74104 0.197008 7.80296C0.258924 7.8654 0.332587 7.91495 0.413748 7.94877C0.494909 7.98259 0.581962 8 0.669885 8C0.757808 8 0.844861 7.98259 0.926022 7.94877C1.00718 7.91495 1.08085 7.8654 1.14276 7.80296L4 4.93866L6.85724 7.80296C6.91915 7.8654 6.99282 7.91495 7.07398 7.94877C7.15514 7.98259 7.24219 8 7.33011 8C7.41804 8 7.50509 7.98259 7.58625 7.94877C7.66741 7.91495 7.74108 7.8654 7.80299 7.80296C7.86542 7.74104 7.91497 7.66737 7.94878 7.58619C7.98259 7.50502 8 7.41795 8 7.33002C8 7.24208 7.98259 7.15502 7.94878 7.07385C7.91497 6.99267 7.86542 6.919 7.80299 6.85708L4.93909 3.99943Z"
                fill="#0E0E0E" />
        </svg>
    </button>

    <div class="dialog_content" mat-dialog-content>
        <p style="
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        text-align: center;
        line-height: 130%;
        letter-spacing: 0.002em;
        color: #0E0E0E;">Are you sure that you want to delete the template message?</p>
        <p style="
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 130%;
        text-align: center;
        letter-spacing: 0.002em;
            color: #0E0E0E;
    " class="pt-2 pb-3">Please note that once deleted will not be retreived</p>

        <div>
            <button (click)="onCancel()" style="
            border: 1px solid #386AF6;
            border-radius: 20px;
            background: none;
            font-weight: 600;
            font-size: 14px;
            line-height: 30px;
            align-items: center;
            justify-content: center;
            width: 37.5%;
            margin-left: 10%;
            color:#386AF6;
            display: inline-flex;
        ">Cancel 
                <mat-icon >
                    <span class="material-symbols-outlined">
                        chevron_right
                    </span>
                </mat-icon></button>
            <button (click)="deleteConfirmation()" style="
            border: 1px solid #386AF6;
            border-radius: 20px;
            background: none;
            font-weight: 600;
            font-size: 14px;
            line-height: 30px;
            align-items: center;
            justify-content: center;
            width: 37.5%;
            color:#386AF6;
            margin-left: 5%;
            display: inline-flex;
        ">Delete
                <mat-icon >
                    <span class="material-symbols-outlined">
                        chevron_right
                    </span>
                </mat-icon>
            </button>

        </div>

    </div>
</ng-template>